// 与后端 MsgBizCode 对齐的可本地化通知类型
const NOTIFICATION_TITLE_KEYS = {
  batteryHigh: 'notification.batteryHighTitle',
  ebikePosture: 'notification.ebikePostureTitle',
  noticeMsg: 'notification.noticeMsgTitle',
  cycleFall: 'notification.cycleFallTitle',
  fenceWarn: 'notification.fenceWarnTitle',
  feedbackReply: 'notification.feedbackReplyTitle',
  ebikeFault: 'notification.ebikeFaultTitle',
  offLine: 'notification.offLineTitle'
}

// 模板化正文（含 {ebikeId}）；运营自由编辑类见 getNotificationContent 注释
const NOTIFICATION_CONTENT_KEYS = {
  batteryHigh: 'notification.batteryHighContent',
  ebikePosture: 'notification.ebikePostureContent',
  cycleFall: 'notification.cycleFallContent',
  fenceWarn: 'notification.fenceWarnContent',
  ebikeFault: 'notification.ebikeFaultContent',
  offLine: 'notification.offLineContent'
}

// bizCode 缺失时，根据中文正文推断类型（兼容历史数据）
const CHINESE_CONTENT_PATTERNS = [
  { pattern: /触发高温告警/, bizCode: 'batteryHigh' },
  { pattern: /触发震动报警/, bizCode: 'ebikePosture' },
  { pattern: /侧翻/, bizCode: 'cycleFall' },
  { pattern: /围栏/, bizCode: 'fenceWarn' },
  { pattern: /故障/, bizCode: 'ebikeFault' },
  { pattern: /离线/, bizCode: 'offLine' }
]

// 运营/用户自由文本，无法做固定 i18n 模板
const RAW_CONTENT_BIZ_CODES = new Set(['noticeMsg', 'feedbackReply'])

export function extractEbikeIdFromContent (content) {
  if (!content || typeof content !== 'string') return ''
  try {
    const json = JSON.parse(content)
    if (json && json.ebikeId) return String(json.ebikeId)
  } catch (e) {
    // not JSON
  }
  const colonMatch = content.match(/车辆[：:]\s*(\S+?)(?:\s|触发|$)/)
  if (colonMatch) return colonMatch[1]
  const lsMatch = content.match(/(LS[A-Za-z0-9]+)/)
  return lsMatch ? lsMatch[1] : ''
}

function resolveBizCode (item) {
  if (item.bizCode) return item.bizCode
  const content = item.content || ''
  for (const entry of CHINESE_CONTENT_PATTERNS) {
    if (entry.pattern.test(content)) return entry.bizCode
  }
  return ''
}

function getNotificationTitle (vm, bizCode) {
  const key = NOTIFICATION_TITLE_KEYS[bizCode]
  return key ? vm.$t(key) : vm.$t('notification.defaultTitle')
}

function getNotificationContent (vm, bizCode, item, ebikeId) {
  // noticeMsg / feedbackReply 正文由运营或客服填写，直接展示原文
  if (RAW_CONTENT_BIZ_CODES.has(bizCode)) {
    return item.content || ''
  }
  const key = NOTIFICATION_CONTENT_KEYS[bizCode]
  if (key) {
    return vm.$t(key, { ebikeId: ebikeId || '-' })
  }
  if (ebikeId) {
    return vm.$t('notification.genericVehicleContent', { ebikeId })
  }
  return item.content || ''
}

export function formatSystemNotification (vm, item) {
  if (!item) {
    return { title: '', time: '', content: '' }
  }
  const bizCode = resolveBizCode(item)
  const ebikeId = extractEbikeIdFromContent(item.content)
  return {
    title: getNotificationTitle(vm, bizCode),
    time: item.msgTime || '',
    content: getNotificationContent(vm, bizCode, item, ebikeId)
  }
}
